import { BotMessageSquare, CornerDownRight, Minus, Plus } from "lucide-react";

const CourePageFAQCard =({coursePageObject})=>{

    return(<>
<div className="themeCoursePage"  style={{marginTop:"50px",overflow:"hidden",
  minHeight:"190px",position:"relative",background:`${coursePageObject?.faqOuterCard?.bgColor?.color}`,
    border:` ${coursePageObject?.faqOuterCard?.border?.borderWidth?.value+coursePageObject?.faqOuterCard?.border?.borderWidth?.resolution} ${coursePageObject?.faqOuterCard?.border?.borderType}  ${coursePageObject?.faqOuterCard?.border?.borderColor?.color}`,
    borderTopLeftRadius:`${coursePageObject?.faqOuterCard?.borderRadius?.topLeft?.value}${coursePageObject?.faqOuterCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.faqOuterCard?.borderRadius?.topRight?.value}${coursePageObject?.faqOuterCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.faqOuterCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.faqOuterCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.faqOuterCard?.borderRadius?.bottomRight?.value}${coursePageObject?.faqOuterCard?.borderRadius?.bottomRight?.resolution}`,
}}>
<div className="themeCoursePage FAQGridTitleCoursePage FAOuterTitleCoursePage  coursePageHeaderFont"  style={{
  borderRadius:"25px",marginTop:"10px",fontWeight:"900",color:coursePageObject?.faqOuterCard?.textColor?.color}}>
   <div style={{marginTop:"-10px",background:coursePageObject?.faqOuterCard?.iconBgColor?.color,width:"60px",height:"60px",borderRadius:"50%",display:"flex",justifyContent:"center",alignItems:"center"}} >

  <BotMessageSquare   strokeWidth={4} absoluteStrokeWidth  size={47}  color={coursePageObject?.faqOuterCard?.iconColor?.color} />
  </div>
  FAQs
  </div>

<div className=" ">
  
<div className="FAQShadowCoursePage" style={{ borderTopLeftRadius:`${coursePageObject?.faqInnerCard?.borderRadius?.topLeft?.value}${coursePageObject?.faqInnerCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.faqInnerCard?.borderRadius?.topRight?.value}${coursePageObject?.faqInnerCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.faqInnerCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.faqInnerCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.faqInnerCard?.borderRadius?.bottomRight?.value}${coursePageObject?.faqInnerCard?.borderRadius?.bottomRight?.resolution}`,
}}>
<div  className="FAQActiveCoursePage" style={{background:`${coursePageObject?.faqInnerCard?.bgColor?.color}`,
    border:` ${coursePageObject?.faqInnerCard?.border?.borderWidth?.value+coursePageObject?.faqInnerCard?.border?.borderWidth?.resolution} ${coursePageObject?.faqInnerCard?.border?.borderType}  ${coursePageObject?.faqInnerCard?.border?.borderColor?.color}`,
    borderTopLeftRadius:`${coursePageObject?.faqInnerCard?.borderRadius?.topLeft?.value}${coursePageObject?.faqInnerCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.faqInnerCard?.borderRadius?.topRight?.value}${coursePageObject?.faqInnerCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.faqInnerCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.faqInnerCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.faqInnerCard?.borderRadius?.bottomRight?.value}${coursePageObject?.faqInnerCard?.borderRadius?.bottomRight?.resolution}`,
}} >
        <div className="themeCoursePage FAQQuestionStyleCoursePage coursePageTitleFont"
        style={{color:`${coursePageObject?.faqInnerCard?.textColor?.color}`}}  > 
 FAQ 1:  This Course Includes Hands On Exercises Videos And Tests 
 
      </div> 
      <div style={{background:`${coursePageObject?.faqInnerCard?.bg2Color?.color}`,width:"40px",height:"40px",borderRadius:"50%"}}><Minus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color={coursePageObject?.faqInnerCard?.iconColor?.color}/> </div>
      </div>

      
      <div  className="FAQItemInnerCoursePage">
      <CornerDownRight   strokeWidth={2} absoluteStrokeWidth  size={23}  color={coursePageObject?.faqInnerCard?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont "
 style={{fontSize:"13px",color:`${coursePageObject?.faqInnerCard?.subTextColor?.color}`,fontWeight:"500"}}> 
   This Course Includes Hands On Exercises Videos And Tests 
 
      </div>
      </div>
      <div  className="FAQItemInnerCoursePage">
      <CornerDownRight   strokeWidth={2} absoluteStrokeWidth  size={23}  color={coursePageObject?.faqInnerCard?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"13px",color:`${coursePageObject?.faqInnerCard?.subTextColor?.color}`,fontWeight:"500"}}> 
  This Course Includes Hands On Exercises Videos And Tests 
  This Course Includes Hands On Exercises Videos And Tests 
  This Course Includes Hands On Exercises Videos And Tests 
      </div>
      </div>
      <div  className="FAQItemInnerCoursePage">
      <CornerDownRight   strokeWidth={2} absoluteStrokeWidth  size={23}  color={coursePageObject?.faqInnerCard?.iconColor?.color}/> 
      <div className="themeCoursePage coursePageSubTitleFont"
 style={{fontSize:"13px",color:`${coursePageObject?.faqInnerCard?.subTextColor?.color}`,fontWeight:"500"}}> 
  This Course Will Equip You With All Inportant Trends In Blender
      </div>
      </div>
      </div>


<div className="FAQShadowCoursePage">
      <div  className="FAQInActiveCoursePage">
        <div className="themeCoursePage FAQQuestionStyleCoursePage coursePageTitleFont"
 style={{color:`${coursePageObject?.faqInnerCard?.textColor?.color}`}} > 
 FAQ 2:  This Course Includes Hands On Exercises Videos And Tests 
 
      </div> 
      <div style={{background:`${coursePageObject?.faqInnerCard?.bgColor?.color}`,width:"40px",height:"40px",borderRadius:"50%"}}><Plus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color={coursePageObject?.faqInnerCard?.iconColor?.color}/> </div>
    
     
      </div>
     
</div>
      
<div className="FAQShadowCoursePage">
      <div  className="FAQInActiveCoursePage">
        <div className="themeCoursePage FAQQuestionStyleCoursePage coursePageTitleFont"
 style={{color:`${coursePageObject?.faqInnerCard?.textColor?.color}`}} > 
 FAQ 3:  This Course Includes Hands On Exercises Videos And Tests 
 
      </div>
       <div style={{background:coursePageObject?.faqInnerCard?.bgColor?.color,width:"40px",height:"40px",borderRadius:"50%"}}><Plus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color={coursePageObject?.faqInnerCard?.iconColor?.color}/> </div>
    
     
      </div>
     
</div>
<div className="FAQShadowCoursePage">
      <div  className="FAQInActiveCoursePage">
        <div className="themeCoursePage FAQQuestionStyleCoursePage coursePageTitleFont"
 style={{color:`${coursePageObject?.faqInnerCard?.textColor?.color}`}} > 
 FAQ 4:  This Course Includes Hands On Exercises Videos And Tests 
 
      </div> 
      <div style={{background:coursePageObject?.faqInnerCard?.bgColor?.color,width:"40px",height:"40px",borderRadius:"50%"}}><Plus strokeWidth={3} absoluteStrokeWidth  size={29} style={{margin:"5px"}}  color={coursePageObject?.faqInnerCard?.iconColor?.color}/> </div>
    
     
      </div>
     
</div>

</div>

  </div>
    </>)
}
export default CourePageFAQCard;